import { asset } from '@/lib/assets'

/** Shared campaign chrome — icons, logos, decor (per-page art lives in config). */
/**
 * Meritlens lockups for campaign chrome, named for the surface they sit on.
 *
 * The asset FILE names are inverted relative to their contents (measured from the PNGs):
 *   meritlens-logo-dark-medium.png  → light ink, luminance 185  → for the dark footer
 *   meritlens-logo-light-medium.png → dark ink,  luminance  71  → for the white header
 * Trust the ink, not the file name — swapping these two puts a washed-out logo on the header.
 */
export const CAMPAIGN_LOGO_ON_LIGHT = asset('/assets/Icons/meritlens-logo-light-medium.png')
export const CAMPAIGN_LOGO_ON_DARK = asset('/assets/Icons/meritlens-logo-dark-medium.png')

export const CAMPAIGN_ICON_FORUM = asset('/assets/images/data-analytics-engineering/icon-forum.svg')
export const CAMPAIGN_ICON_MENU_BOOK = asset(
  '/assets/images/data-analytics-engineering/icon-menu-book.svg',
)
export const CAMPAIGN_ICON_FEEDBACK = asset(
  '/assets/images/data-analytics-engineering/icon-feedback.svg',
)
export const CAMPAIGN_ICON_TROPHY = asset('/assets/images/data-analytics-engineering/icon-trophy.svg')
export const CAMPAIGN_ICON_CHECK = asset(
  '/assets/images/data-analytics-engineering/icon-check-circle.svg',
)
export const CAMPAIGN_ICON_CTA_ARROW = asset(
  '/assets/images/data-analytics-engineering/icon-arrow-forward.svg',
)
export const CAMPAIGN_DEFAULT_OFFER_PREVIEW = asset(
  '/assets/images/data-analytics-engineering/offer-card-preview.png?v=20261030',
)

/** Figma desktop decor: purple grid + circle (replaces CSS heroDecorHalfCircleFill when set on config). */
export const CAMPAIGN_PAGE_BACKGROUND = asset(
  '/assets/images/data-analytics-engineering/page-background.png',
)

export const CAMPAIGN_CLAIM_UNAVAILABLE =
  'Mock interview purchase is not available right now. Please try again in a moment.'
